import { SagaIterator } from "redux-saga";
import { call, select, takeLatest } from "redux-saga/effects";
import factory from "utils/getApiHandlerEffect";
import history from "utils/history";
import storage from "../../persistance";
import { buildRedirectUrl, findApplication, getUsableUrl } from "./accessCheck";
import { setTransferContext } from "./redux";
import { selectPlatformTransfer } from "./selectors";

const RESOURCE_ID_KEY = "resourceId";
const DASHBOARD_PATH = "/dashboard";

export function* onTransferContextSet(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: ReturnType<typeof setTransferContext>
): SagaIterator {
  const { platform, application, cidpId, partnerId } = yield select(
    selectPlatformTransfer
  );

  let url: string | null = null;
  try {
    const apiHandler: APIHandler = yield call(() => factory());
    const response = yield call(() => apiHandler.getUserApplications(cidpId));
    url = getUsableUrl(findApplication(response, platform, application));
  } catch (e) {
    url = null;
  }

  storage.removeItem(RESOURCE_ID_KEY);
  if (url) {
    window.location.replace(buildRedirectUrl(url, partnerId));
  } else {
    history.replace(DASHBOARD_PATH);
  }
}

// watcher function
export default function* platformTransferSaga() {
  yield takeLatest(setTransferContext.type, onTransferContextSet);
}
